export default __webpack_public_path__ + "images/435b3e0b09cdc4b2e5a50c80a83b6de6.svg";